import { useState } from 'react';

import { IAppFile } from '../types/interfaces/app-file';
import { INewFile } from '../types/interfaces/new-file';
import { uploadFilesUtils } from '../utils/files/upload-files-utils';

export function useFileList(files: IAppFile[]) {
  const [fileIdsToDelete, setFileIdsToDelete] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState<INewFile[]>([]);

  async function onUploadFiles(files: FileList | null, uploadPreview = false) {
    if (!files?.length) {
      return;
    }

    const uploadedFiles = (await uploadFilesUtils(files, uploadPreview)).filter(
      Boolean,
    );

    setFilesToUpload((prev) => [...prev, ...uploadedFiles] as any);
  }

  function onDeleteFile(id: number | string) {
    if (typeof id === 'string') {
      setFileIdsToDelete((prev) => [...prev, id]);
    } else {
      setFilesToUpload((prev) => prev.filter((f) => f.id !== id));
    }
  }

  function getResultFiles(): (INewFile | IAppFile)[] {
    return [
      ...files.filter((f) => !fileIdsToDelete.some((fid) => fid === f.id)),
      ...filesToUpload,
    ];
  }

  function resetFilesState() {
    setFilesToUpload([]);
    setFileIdsToDelete([]);
  }

  return {
    fileIdsToDelete,
    filesToUpload,
    resultFiles: getResultFiles(),
    onDeleteFile,
    onUploadFiles,
    resetFilesState,
  };
}
